package ui.app.assign.detail.kindergarten.preview

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import apps.App
import common.frontend.api.Io
import provider.CommonDisplayProvider
import provider.LocalAccountProvider
import provider.LocalDisplayProvider
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel
import tools.EFieldList
import ui.app.assign.detail.AppDetailArgs
import ui.app.assign.detail.kindergarten.AppKindergartenScope


class AppKindergartenPreviewScope private constructor(
    val vm: AppKindergartenPreviewVM,
    val action: (AppKindergartenPreviewVM.Action) -> Unit,
    override val args: AppDetailArgs,
    override val nav: Navigation,
    override val login: Io.User,
    override val display: CommonDisplayProvider
) : AppKindergartenScope {

    companion object {
        @Composable
        fun rememberScope(): AppKindergartenPreviewScope {
            val nav = LocalNavigation.current
            val account = LocalAccountProvider.current
            val display = LocalDisplayProvider.current
            val args = LocalNavigationArgs.current.rememberArgs(AppDetailArgs::class)
            val vm = nav.viewModel(AppKindergartenPreviewVM::class, "${args.companyId}:${args.appId}")
            val action = AppKindergartenPreviewVM.Action.rememberAction(vm)
            return remember {
                AppKindergartenPreviewScope(
                    vm = vm,
                    action = action,
                    args = args,
                    nav = nav,
                    login = account.current!!,
                    display = display
                )
            }
        }
    }


    init {
        vm.init(this)
    }

    class Wrapper(
        val canEdit: Boolean,
        val canDelete: Boolean,
        override val data: Io.AppDetail,
        override val key: String = data.id.toString()
    ) : EFieldList.Entry<Io.AppDetail> {


        val appRef: App.Kindergarten get() = data.data as App.Kindergarten


    }
}